import React from 'react';
import IdeaList from '@/components/ideas/IdeaList';
import { IDEA_INDEX } from '@/constants/app';
import useIdeaList from '@/hooks/useIdeaList';

const IdeaListContainer: React.FC = () => {
  const ideaList = useIdeaList();
  return <IdeaList title={IDEA_INDEX} ideaList={ideaList} showIndex={true} />;
};

export default IdeaListContainer;
